<template>
  <div class="Material_management">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="图片" name="first">
         <Picture_management />
      </el-tab-pane>
      <el-tab-pane label="音频" name="second">
         <Audio_management />
      </el-tab-pane>
      <el-tab-pane label="视频" name="third">
         <Video_management />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Picture_management from './Picture_management'
import Audio_management from './Audio_management'
import Video_management from './Video_management'
export default {
  data() {
    return {
      activeName: 'first',
    }
  },
  mounted() {
  },
  components:{
    Picture_management,
    Audio_management,
    Video_management,
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
}
</script>
<style> 
.el-button--text{color: #000;}
.Material_management{height: 100%;background-color: #fff;min-width: 1600px;min-height: 1100px;}
.Material_management .el-tabs{min-width: 1400px;}
.Material_management .el-tabs__nav{margin-left: 15px;}
.tp{width: 100%;height: 100%;padding:0px 15px 15px 15px;}
.Material_management .input-with-select{width: 300px;margin-left: 200px;}
.Material_management .tp_ul1{width: calc(100% - 320px);display: inline-block;}
.Material_management .tp_ul1 li{float: left;width: 200px;text-align: center;line-height: 34px;text-align: center;cursor: pointer;}
.Material_management .Select{color: rgba(0, 136, 255, 1);box-shadow:0 0 1px 1px rgba(0, 136, 255, 1);border-radius: 20px;}
.Material_management .nav_ul{height: 880px;}
.Material_management .nav_ul li{width: 300px;height: 230px;float: left;margin-left: 15px;margin-top: 15px;position: relative;}
.Material_management .nav_ul li img{width: 300px;height: 168.75px;}
.Material_management .nav_ul li p{width: 100%;text-align: center;font-weight: 700;margin-top: 15px;border-radius: 5px;}
.select{border: 1px solid #123456;}
.Material_management .nav_ul li:hover .cz{display: block;}
.Material_management .nav_ul .sibling{height: 104px;width: 72px;background: #fff;position: absolute;top:45px;right: 10px;display: none;}
.Material_management .nav_ul .cz{display: none;}
.Material_management .nav_ul .cz:hover + .sibling {display: block;}
.Material_management .nav_ul .sibling:hover{display: block;}
.Material_management .sibling ul{width: 100%;height: 100%;}
.Material_management .sibling ul li{width: 100%;text-align: center;height: 26px;margin: 0px;font-size: 12px;cursor: pointer;line-height: 26px;}
.Material_management .sibling ul li:hover{background-color: rgba(242, 242, 242, 1)}
</style>
